//
// Note that unpoly is required as own module in app.html and available as `up`
// (via window.up).
//
// Dependency to jQuery will be removed in the future.
import jQuery from 'jquery'

import * as cs from './cs/cs.mjs';
import Form from "./cs/Form.js";

window.jQuery = window.$j = jQuery.noConflict();
window.cs = cs;

window.addEventListener('load', function () {
  if (csENV.env == 'development') {
    up.log.enable();
  }

  if (cs.q('.boats.edit')) {
    Form.init({form: '.js-boat-form'});
  }

  if (cs.q('.tariffs.edit')) {
    Form.init({form: '.js-tariff-form'});
  }

  if (cs.q('.boat_add_ons.edit')) {
    Form.init({form: '.js-boat-add-on-form'});
  }

  if (cs.q('.personal_data.edit')) {
    Form.init({form: '.js-client-form'});
  }

  if (cs.q('.payments.edit')) {
    Form.init({form: '.js-payment-form'});
  }

  // This ensures that the select gets a Select2 on first page load and after
  // each replacement via unpoly.
  // up.compiler(".js-replaceable-container]", function (element) {
  // })

}, false);
